import apiClient from '@/services/api-client';

export const setSimulatedSupplier = async (params) => {
  const response = await apiClient.get('/admin/set/simulated-supplier', {params});
  return response.data;
};